
export const massesH5Router = [
  {
    path: '',
    redirect: 'index'
  },
  {
    path: 'index',
    meta: {
      title: '海淀区科技类校外培训行业规范发展服务平台',
      needLogin: false // 是否需要登录才能访问
    },
    component: () => import('../views/h5/pages/index'),
  },
  {
    path: 'publicizeList',
    meta: {
      title: '宣传信息',
      needLogin: false // 是否需要登录才能访问
    },
    component: () => import('../views/h5/pages/publicizeList'),
  },
  {
    path: 'policyList',
    meta: {
      title: '政策法规',
      needLogin: false // 是否需要登录才能访问
    },
    component: () => import('../views/h5/pages/policyList'),
  },
  {
    path: 'technologyList',
    meta: {
      title: '科技专栏',
      needLogin: false // 是否需要登录才能访问
    },
    component: () => import('../views/h5/pages/technologyList'),
  },
  {
    path: 'orgList',
    meta: {
      title: '开通资金监管账户机构名单',
      needLogin: false // 是否需要登录才能访问
    },
    component: () => import('../views/h5/pages/orgList'),
  },
  {
    path: 'yiList',
    meta: {
      title: '海淀区已取得科技类《非学科类校外培训机构培训许可证》机构名单及星级评定情况',
      needLogin: false // 是否需要登录才能访问
    },
    component: () => import('../views/h5/pages/yiList'),
  },
  {
    path: 'weiList',
    meta: {
      title: '海淀区未取得科技类《非学科类校外培训机构培训许可证》机构名单及星级评定情况',
      needLogin: false // 是否需要登录才能访问
    },
    component: () => import('../views/h5/pages/weiList'),
  },
  {
    path: 'yuList',
    meta: {
      title: '风险预警机构名单',
      needLogin: false // 是否需要登录才能访问
    },
    component: () => import('../views/h5/pages/yuList'),
  },
  {
    path: 'detail',
    meta: {
      title: '',
      needLogin: false // 是否需要登录才能访问
    },
    component: () => import('../views/h5/pages/detail'),
  }
]




export default massesH5Router
